export { default } from 'shared/components/button'
